/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FormikProps } from 'formik';
import { Campaign } from '../../../../../types/Campaign.type';
import {
  BlogInput,
  MarketingIdeasInput,
  ContentImproverInput,
  EmailInput,
  SocialInput,
  PersonaSocialInput,
  PersonaMarketingIdeasInput,
} from '../../../../../types/FormTypes';
import { NextImageBasicData } from '../../../../../types/Next';
import { BasicButtonSelectionInput } from '../../../../shared/inputs/BasicButtonSelectionInput';
import { BasicInput } from '../../../../shared/inputs/BasicInput';
import React from 'react';

type IntentInputProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
  defaultOptions?: string[];
  defaultOptionIcons?: NextImageBasicData[];
  title?: string;
  subtitle?: string;
};





export function IntentInput<
  T extends BlogInput | SocialInput | EmailInput | Campaign |PersonaSocialInput | PersonaMarketingIdeasInput
>({ formikProps, disabled }: IntentInputProps<T>) {
  return (
    <BasicInput
      id="intent"
      label={
        <div>
          <h2>What is the goal?</h2>
          <p>
            Describe the intent of the copy. Ex: Convince startup founders to
            sign up for our newsletter.
          </p>
        </div>
      }
      placeholder={'Goal & intent of copy'}
      value={formikProps.values.intent}
      setValue={formikProps.handleChange('intent')}
      disabled={disabled}
      errors={formikProps.errors.intent as string}
      touched={formikProps.touched.intent ? true : false}
      onBlur={formikProps.handleBlur}
    />
  );
}

export function IntentSelectionInput<
  T extends MarketingIdeasInput | ContentImproverInput | PersonaMarketingIdeasInput
>({
  formikProps,
  disabled,
  defaultOptions,
  defaultOptionIcons,
  title = 'What is the goal?',
  subtitle = 'Please select the desired outcome.',
}: IntentInputProps<T>) {
  return (
    <BasicButtonSelectionInput
      id="intent"
      label={
        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
      }
      defaultOptions={defaultOptions || []}
      defaultOptionIcons={defaultOptionIcons}
      value={formikProps.values.intent}
      setValue={formikProps.handleChange('intent')}
      disabled={disabled}
      errors={formikProps.errors.intent as string}
      touched={formikProps.touched.intent ? true : false}
      onBlur={formikProps.handleBlur}
    />
  );
}
